import {User} from "./User";
import {HardDeletionMarkable} from "./index";
import {WorkspaceSubscriptionSummary} from "./subscription/workspaceSubscription";
import {WorkspaceCard} from "./transaction/transaction";

export interface Workspace {
    _id: string;
    workflowUserId: string
    important: boolean;
    userId: string
    name?: string
    timezone: string
    description?: string
    creating_progress_rate: number
    dataClusterId: string
    chatbotClusterId: string
}

export interface WorkspaceAggregation extends Workspace, HardDeletionMarkable {
    _id: string;
    chatbotClusterId: string
    deleted?: boolean;
    createdAt: string;
    updatedAt: string;
    deletedAt?: string
    user?: User
    workspaceSubscription?: WorkspaceSubscriptionSummary
    card?: WorkspaceCard
}

export interface workspacePage {
    workspaces: WorkspaceAggregation[],
    count: number
    totalCount: number
}

export enum SearchTypeEnum {
    WORKSPACENAME = 'workspace_name',
    USEREMAIL = 'user_email',
}
export type SearchType = SearchTypeEnum.WORKSPACENAME | SearchTypeEnum.USEREMAIL
export const isSearchType = (text?: unknown): text is SearchType => {
    return (text === SearchTypeEnum.WORKSPACENAME || text === SearchTypeEnum.USEREMAIL);
}